export const BookingWidgetFields = {
  heading: {
    type: "text",
    label: "Heading",
    metadata: {
      source: "manual",
      description: "Booking section heading (e.g. 'Book your service')",
      seo: true,
    },
  },
  subheading: {
    type: "text",
    label: "Subheading",
    metadata: {
      source: "manual",
      description: "Short inviting line under the booking heading",
      seo: true,
    },
  },
  backgroundColor: {
    type: "text",
    label: "Background Color (optional)",
    metadata: {
      source: "manual",
      advanced: true,
    },
  },
} as const;
